export enum DraftPresentationType {
    fuf = "fuf",
    inner = "inner",
    printed = "printed",
    requisites = "requisites",
    errorLog = "errorLog",
    clientRequisites = "clientRequisites",
    clientInfo = "clientInfo",
    hlInner = "hlInner",
    innerFuf = "innerFuf",
    outer = "outer",
    fufWithAttachments = "fufWithAttachments",
    formsClientInfo = "formsClientInfo",
    errorlogExpert = "errorlogexpert",
    explanatoryNote = "explanatorynote",
}
